import { Link } from '@tanstack/react-router';
import { SignupForm } from '../components/SignupForm';
import type { SignupInput } from '../api/auth';
import { useT } from '../i18n';

interface Props {
  onSignup: (input: SignupInput) => Promise<void>;
}

// ANX-055: site-key подставляется во время сборки через build-arg
// VITE_TURNSTILE_SITE_KEY. Если не задан — Turnstile-виджет не
// рендерится, защита signup'а полагается на server-side rate-limit.
const TURNSTILE_SITE_KEY =
  (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ?? '';

export function SignupView({ onSignup }: Props) {
  const t = useT();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-card">
        <h1 className="text-xl font-semibold text-slate-900">{t('signup.title')}</h1>
        <p className="mb-4 mt-1 text-sm text-slate-500">{t('signup.subtitle')}</p>
        <SignupForm
          onSubmit={onSignup}
          {...(TURNSTILE_SITE_KEY ? { turnstileSiteKey: TURNSTILE_SITE_KEY } : {})}
        />
        <p className="mt-4 text-center text-xs text-slate-500">
          <Link to="/login" className="text-accent-600 hover:text-accent-700">
            {t('signup.loginLink')}
          </Link>
        </p>
      </div>
    </div>
  );
}
